import { use_slice_generation, use_slice_ui } from '@/hooks/store/use_slices';
import { not_implemented_type } from '@shared/asserts/utils_asserts';
import { DTO_GRAPH__edge } from '@shared/dto/generation/graph_invoke/_graph/DTO_GRAPH__edge';
import { G_BUTTON__edge_ui_change_visibility } from './G_BUTTON__edge_ui_change_visibility';

interface PROPS {
  edge: DTO_GRAPH__edge;
  name_type: 'from' | 'to' | 'full';
}

export function G_SIDEBAR__edges_item({ edge, name_type }: PROPS) {
  const { g_general__ui_disabled } = use_slice_ui(['g_general__ui_disabled']);
  const { generation_current } = use_slice_generation(['generation_current']);

  /*
   *
   */
  let { graph } = generation_current.tool;

  /*
   * EVENTS
   */

  /*
   * METHODS
   */
  function get_name() {
    let edge_from_graph = graph.edges.find(item => item.edge_id == edge.edge_id);
    if (!edge_from_graph) return '';

    let field_from = graph.field__get_by_id(edge.field_from__field_id);
    let field_to = graph.field__get_by_id(edge.field_to__field_id);

    let out = '';

    switch (name_type) {
      case 'from':
        out = `${field_from.meta.sort_criteria} →`;
        break;
      case 'to':
        out = `→ ${field_to.meta.sort_criteria}`;
        break;
      case 'full':
        out = `${field_from.meta.sort_criteria} → ${field_to.meta.sort_criteria}`;
        break;

      default:
        not_implemented_type(name_type);
    }

    return out;
  }

  /*
   * HTML
   */

  if (generation_current.is_stub()) return null;

  // id {edge.edge_id}
  //   is enabled {edge.is_enabled ? 'true' : 'false'}
  return (
    <div className="flex flex-row flex-center-horizontal gap-1 w-full px-1">
      <G_BUTTON__edge_ui_change_visibility {...{ edge }} />

      <label
        className={`flex-1  text-xs text-component-item-foreground truncate  
        ${g_general__ui_disabled ? '!cursor-not-allowed' : 'cursor-pointer'}
        `}
      >
        {get_name()}
      </label>
    </div>
  );
}
